export enum ReviewPermissions {
  SetUpModeration = 'set_up_moderation',
  ViewSubmissions = 'view_submissions',
  AcceptSubmissions = 'accept_submissions',
  RejectSubmissions = 'reject_submissions',
  WithdrawSubmissions = 'withdraw_submissions',
  EditReviewComments = 'edit_review_comments',
  ViewActions = 'view_actions',
  AddModerator = 'add_moderator',
  UpdateModerator = 'update_moderator',
  RemoveModerator = 'remove_moderator',
  EditReviewSettings = 'edit_review_settings',
  AddReviewer = 'add_reviewer',
  AssignReviewer = 'assign_reviewer',
  ViewAssignedSubmissions = 'view_assigned_submissions',
  ReviewAssignedSubmissions = 'review_assigned_submissions',
}
